
import './style.scss';
import { Fastfood } from '@mui/icons-material';
import { IPointOfSaleItem } from '../../interfaces/IPartnerPms';
import { Avatar, Box, Divider, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import MaskHelper from '../../helpers/MaskHelper';


interface IPointOfSaleItemsList {
    items: IPointOfSaleItem[];
    avatar?: (item: IPointOfSaleItem) => JSX.Element | JSX.Element[];
    actions?: (item: IPointOfSaleItem) => JSX.Element | JSX.Element[];
}


const PointOfSaleItemsList: React.FC<IPointOfSaleItemsList> = ({
    items,
    avatar = undefined,
    actions = undefined
}) => {
    return (
        <List className='pointofsaleitemslist-default'>
            {
                items.map((item, index) => {
                    return <>
                        {
                            index > 0 && <Divider variant="inset" component="li" />
                        }

                        <ListItem className='pointofsale-item' key={item.id}>
                            <ListItemAvatar>
                                {
                                    avatar ? avatar(item) : (
                                        <Avatar className='backgroundcolor-default'>
                                            <Fastfood />
                                        </Avatar>
                                    )
                                }
                            </ListItemAvatar>

                            <ListItemText primary={item.name} secondary={MaskHelper.Money(item.price)} className='pointofsaleitem-title' />

                            {
                                actions && (
                                    <Box className='pointofsaleitem-actions'> 
                                        {actions(item)} 
                                    </Box>
                                )
                            }
                        </ListItem>
                    </>;
                })
            }
        </List>
    );
}

export default PointOfSaleItemsList;